export function UpdateProfilePage() {
  return (
    <main className="max-w-2xl" role="main">
      <section className="mb-8">
        <header className="mb-8">
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-semibold text-neutral-950">
              Update Profile
            </h1>
          </div>
        </header>
      </section>
    </main>
  );
}
